import { PRODUCT_YOU_MIGHT_BE_INTO_LOCAL_STORAGE_KEY } from '@/modules/product/constants';
import { type YouMightBeIntoLocalStorageItem } from '@/modules/product/types';
import { getLocalStorageItem, setLocalStorageItem } from '@/modules/storage';
import { safeJsonParse } from '@/modules/storage/helpers';

export function addYouMightBeIntoItemToLocalStorage({
  brandId,
  groupId,
  isKids = false,
  gender,
  productType,
}: YouMightBeIntoLocalStorageItem) {
  const brandedCategoryList = getLocalStorageItem(
    PRODUCT_YOU_MIGHT_BE_INTO_LOCAL_STORAGE_KEY
  );
  const parsedBrandedCategoryList = safeJsonParse(brandedCategoryList, []);
  const updatedBrandedCategoryList = Array.from(
    new Set([
      // Stringify the object so that each data set is unique
      // This will prevent pills with the same search suggestions appearing in the "You Might Be Into" module
      JSON.stringify({ brandId, groupId, isKids, gender, productType }),
      ...parsedBrandedCategoryList,
    ])
  ).slice(0, 12);

  setLocalStorageItem(
    PRODUCT_YOU_MIGHT_BE_INTO_LOCAL_STORAGE_KEY,
    JSON.stringify(updatedBrandedCategoryList)
  );
}
